import { GET_ORDER_ITEMS, UPDATE_ORDER_DETAILS, SET_UPLOAD_ORDERS_FILE_ACTION, SET_UPLOAD_ORDERS_FILE_BATCH } from './types';
import { getDentalCorpBackend } from '../commons/backend/dentalCorpBackendProxy';
import { SPJ_ACTIONS, SPJ_STATUS } from '../commons/utils';
import { UploadOrdersFileActions } from '../components/OrdersV2/Utils';

const dentalCorpBackend = getDentalCorpBackend();

export const getOrderItems = (page, size, status, startDate, endDate, custId = '', groupId = '', searchText = '') => {
	if (custId === undefined || custId === null || custId === 'undefined' || custId === 'null') {
		custId = '';
	}
	return async (dispatch, getState) => {
		let response = await dentalCorpBackend.getSalesByDate(getState(), startDate, endDate, status, page, size, custId, groupId, searchText, dispatch);
		if (response !== null && response !== undefined) {
			dispatch({ type: GET_ORDER_ITEMS, payload: response.response });
		}
	};
};

export const getOrderDetails = (orderId) => {
	return async (dispatch, getState) => {
		let response = await dentalCorpBackend.getOrderById(getState(), orderId, dispatch);
		if (response !== null && response !== undefined) {
			dispatch({ type: UPDATE_ORDER_DETAILS, payload: response.response });
		}
	};
};

export const updateOrderLines = (orderId, body, onSuccess = null) => {
	return async (dispatch, getState) => {
		let response = await dentalCorpBackend.updateOrderLines(getState(), orderId, body, dispatch);
		if (response !== null && response !== undefined) {
			onSuccess();
		}
	};
};

export const downloadOrderItems = (action = '', status, startDate, endDate, custId = '', groupId = '', searchText = '', downloadTrackingTemplate = false) => {
	if (custId === undefined || custId === null || custId === 'undefined' || custId === 'null') {
		custId = '';
	}
	return async (dispatch, getState) => {
		await dentalCorpBackend.downloadSalesByDate(getState(), action, startDate, endDate, status, custId, groupId, searchText, downloadTrackingTemplate, dispatch);
	};
};

export const setUploadOrdersFileAction = (showUploadOrdersFile = false, uploadOrdersFileType = '', uploadOrdersFileAction = '') => {
	return async (dispatch, getState) => {
		dispatch({ type: SET_UPLOAD_ORDERS_FILE_ACTION, payload: { showUploadOrdersFile, uploadOrdersFileType, uploadOrdersFileAction } });
	};
};

export const setUploadOrdersFileBatch = (uploadOrdersFileBatch = '') => {
	return async (dispatch, getState) => {
		dispatch({ type: SET_UPLOAD_ORDERS_FILE_BATCH, payload: { uploadOrdersFileBatch } });
	};
};

export const fetchUploadOrdersFileBatch = () => {
	return async (dispatch, getState) => {
		const actionTypes = [SPJ_ACTIONS.SALES_ORDER_UPDATE];
		const pendingBatches = await dentalCorpBackend.fetchSPJActiveBatches(getState(), SPJ_STATUS.PENDING, '', dispatch);
		if (pendingBatches && pendingBatches.length > 0 && actionTypes.includes(pendingBatches[0].event)) {
			let pendingBatch = pendingBatches[0];
			await dispatch(setUploadOrdersFileBatch(pendingBatch.batch_id));
			await dispatch(setUploadOrdersFileAction(true, pendingBatch.event, UploadOrdersFileActions.PROCESSING));
		} else {
			const failedBatches = await dentalCorpBackend.fetchSPJActiveBatches(getState(), SPJ_STATUS.FAILED, '', dispatch);
			if (failedBatches && failedBatches.length > 0 && actionTypes.includes(failedBatches[0].event)) {
				let failedBatch = failedBatches[0];
				await dispatch(setUploadOrdersFileBatch(failedBatch.batch_id));
				await dispatch(setUploadOrdersFileAction(true, failedBatch.event, UploadOrdersFileActions.FILE_ERRORS));
			}
		}
	};
};

export const downloadTemplateFile = (action = '', onFailure = null) => {
	return async (dispatch, getState) => {
		await dentalCorpBackend.downloadTemplateFile(getState(), action, dispatch);
	};
};

export const uploadFilledTemplateFile = (action = '', body, onSuccess = null, onFailure = null) => {
	return async (dispatch, getState) => {
		await dentalCorpBackend.uploadFilledTemplateFile(getState(), action, body, onSuccess, onFailure, dispatch);
	};
};
